export default function summarizeJobWorkInstructions(instructionLists) {
  const instructionCount = (instructionLists || []).reduce(
    (sum, instructions) => sum + (instructions?.length || 0),
    0
  );

  return {
    hasInstructions: instructionCount > 0,
    instructionCount,
  };
}
